import { Flex, Image, Text, Box } from '@chakra-ui/react';
import React from 'react';

import useApiQuery from 'lib/api/useApiQuery';
import CurrencyValue from 'ui/shared/CurrencyValue';

interface Props {
  address: string;
}

const UserWalletTokenBalances = ({ address }: Props) => {
  const { data, isLoading } = useApiQuery('general:address_token_balances', {
    pathParams: { hash: address },
    queryOptions: {
      enabled: Boolean(address),
    },
  });

  if (!data || data.length === 0) {
    return null;
  }

  // Limit to top 5 tokens
  const tokens = data.slice(0, 5);

  return (
    <Flex direction="column" gap={ 2 } mt={ 2 }>
      { tokens.map((item, index) => (
        <Flex key={ index } alignItems="center" justifyContent="space-between" fontSize="sm">
          <Flex alignItems="center" gap={ 2 }>
            { item.token.icon_url ? (
              <Image src={ item.token.icon_url } boxSize="16px" borderRadius="full" alt={ item.token.symbol || 'Token' }/>
            ) : (
              <Box boxSize="16px" borderRadius="full" bg="gray.200"/>
            ) }
            <Text fontWeight={ 500 } fontSize="xs">{ item.token.symbol }</Text>
          </Flex>
          <CurrencyValue
            value={ item.value }
            decimals={ item.token.decimals }
            currency=""
            accuracy={ 4 }
            isLoading={ isLoading }
            fontSize="xs"
          />
        </Flex>
      )) }
    </Flex>
  );
};

export default React.memo(UserWalletTokenBalances);
